<script>
export default {
  data() {
    return {
      filters: {
        available: [
          {
            name: 'Is active',
            query_param: 'is_active',
            options: [
              { label: 'Yes', value: 'true' },
              { label: 'No', value: 'false' }
            ]
          },
          {
            name: 'Is applicant',
            query_param: 'is_applicant',
            options: [
              { label: 'Yes', value: 'true' },
              { label: 'No', value: 'false' }
            ]
          }
        ],
        selected: {
          is_applicant: 'false'
        }
      }
    }
  },
  methods: {
    parseOption(option) {
      return { label: option.name, value: option.id }
    }
  }
}
</script>
